import React from 'react';
import { TestIdProps } from '@tanium/coreui-utils';
import { ButtonBase } from '@tanium/react-button-base';
import styled from '@tanium/react-emotion';
import { CloseIcon } from '@tanium/react-graphics';
import { css } from '@tanium/style-system';
import { ThemeSpace } from '@tanium/theme-data';
import { useTranslation } from './localization';
import { DismissButtonActive, DismissButtonFill, DismissButtonHover } from './themeDefinitions';

interface Props extends React.PropsWithoutRef<JSX.IntrinsicElements['button']>, TestIdProps {}

const StyledButton = styled(ButtonBase)(
  css((theme) => {
    const minorSpace = 'minor' in theme.space ? theme.space.minor[1] : 4;
    return {
      p: ThemeSpace.minor[1],
      m: `${-1 * minorSpace}px`,
      bg: 'transparent',
      border: 0,
      color: DismissButtonFill,
      ':hover': {
        color: DismissButtonHover,
      },
      ':active': {
        color: DismissButtonActive,
      },
    };
  }),
);

export const DismissButton = ({ ...props }: Props) => {
  const { t } = useTranslation();
  return (
    <StyledButton aria-label={t('Dismiss')} type="button" {...props}>
      <CloseIcon height={12} width={12} focusable={false} />
    </StyledButton>
  );
};
